module.exports = __webpack_public_path__ + "img/bank.e8a1be2b.svg";